<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span class="crumb" @click="$router.push({path: '/'})">首页</span>
        <span>></span>
        <span class="crumb" @click="$router.push({path: '/my_vote'})">投票</span>
        <span>></span>
        <span>{{info.title}}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="banner">
            <img :src="info.cover_url" alt v-if="info.cover_url.indexOf(',') == -1" />
            <img :src="info.cover_url.split(',')[0]" alt v-else />
          </div>
          <div class="info">
            <div class="info-top">
              <div class="message">
                <p>{{info.title}}</p>
                <div
                  class="mic"
                  v-if="info.article_type == 'sound' || info.article_type == 'voice'"
                >
                  <img src="@/assets/img/icon_mic.png" alt />
                </div>
              </div>
              <div class="message">
                <div class="num">
                  <span>{{info.display_time | timefilters}} · {{info.read_time}}分钟阅读 · {{info.word_times}}字</span>
                  <span
                    class="laber"
                    v-if="info.article_type == 'magazine'"
                    @click="goLaber(info.column.id)"
                  >#{{info.column.name}}</span>
                  <span
                    class="laber"
                    v-if="info.article_type == 'magazine'"
                    @click="goLaber(info.column.parent_column.id)"
                  >#{{info.column.parent_column.name}}</span>
                  <!-- 普通文章 -->
                  <span
                    class="laber"
                    v-if="info.article_type == 'normal'"
                    v-for="(item,i) in info.topics"
                    :key="i"
                    @click="goLaber(item.id)"
                  >#{{item.name}}</span>
                  <!--音频文章 -->
                  <span
                    class="laber"
                    v-if="info.article_type == 'sound' || info.article_type == 'voice'"
                    v-for="(item,i) in info.really_tags"
                    :key="i"
                    @click="aboutLaber(item)"
                  >#{{item}}</span>
                </div>
                <div class="num">
                  <div>
                    <img src="@/assets/img/like2.png" alt v-if="info.is_like" @click="praiseBtn" />
                    <img src="@/assets/img/like1.png" alt v-else @click="praiseBtn" />
                    <span>{{info.like_times}}人点赞</span>
                  </div>
                  <div>
                    <img
                      src="@/assets/img/collection1.png"
                      alt
                      v-if="info.is_favorited"
                      @click="collectionBtn"
                    />
                    <img src="@/assets/img/collection.png" alt v-else @click="collectionBtn" />
                    <span>{{info.favorite_times}}人收藏</span>
                  </div>
                </div>
              </div>
              <div class="summary">{{info.summary}}</div>
              <div style="position: relative;">
                <div
                  class="content"
                  v-html="info.content"
                  :class="{showall:true,active:showall}"
                >{{info.content}}</div>
                <div class="cont-mask" v-if="!showall">
                  <img src="@/assets/img/cont_mask.png" alt />
                </div>

                <div
                  class="mui-text-center imgbtn"
                  :class="{active:showall}"
                  @click="all"
                  v-if="!showall"
                >
                  查看所有
                  <img src="@/assets/img/down_arrow.png" alt />
                </div>
              </div>
              <!-- <div class="praise">
                <img src="@/assets/img/icon_praise.png" alt />
                <p>{{info.commentNum}}</p>
              </div>-->
              <div class="vote" style="margin-top:11%" v-if="info && info.votes && info.votes[0]">
                <p
                  class="tit"
                >{{info.votes[0].title}}（{{info.votes[0].category == 'simple' ? '单选' : '多选'}}）</p>
                <ul>
                  <li v-for="(item,i) in info.votes[0].vote_items" :key="i">
                    <div class="img">
                      <img :src="item.cover_url" alt />
                    </div>
                    <div
                      class="progress"
                      :style="'width:'+item.percent+ '%'"
                      :class="item.is_selected == true? 'addClass': 'otherClass'"
                    >
                      <div class="cont">
                        <p>{{item.title}}</p>
                        <p>{{item.summary}}</p>
                      </div>
                      <div class="per">{{item.percent}}%</div>
                    </div>
                  </li>
                </ul>
                <el-button class="voted">已投票</el-button>
              </div>
              <div class="comment">
                <p class="title">评论</p>
                <div class="comment-box">
                  <div class="img">
                    <img src="@/assets/img/avatar.png" alt v-if="showAvatar" />
                    <img :src="avatar" alt v-else />
                  </div>
                  <div class="commentInput">
                    <el-input
                      type="textarea"
                      :rows="5"
                      v-model="commentCont"
                      maxlength="200"
                      show-word-limit
                    ></el-input>
                    <div>
                      <el-button @click="publishBtn">发表</el-button>
                    </div>
                  </div>
                </div>
                <div>
                  <ul class="evaluate">
                    <li v-for="(item,i) in evaluateList" :key="i">
                      <div class="img" v-if="item.user">
                        <img :src="item.user.avatar" alt />
                      </div>
                      <div class="cont">
                        <p class="name" v-if="item.user">{{item.user.nickname}}</p>
                        <p class="time">{{item.display_time | timefilters}}</p>
                        <div>{{item.content}}</div>
                      </div>
                      <div class="like">
                        <span>{{item.like_times}}</span>
                        <img
                          src="@/assets/img/like1.png"
                          alt
                          v-if="item.is_like == false"
                          @click="commentBtn(item.id, i)"
                        />
                        <img src="@/assets/img/like2.png" alt v-else @click="commentBtn(item.id,i)" />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <AboutAuthor :artAuthorList="authors"></AboutAuthor>
          <AboutArticle :child="id"></AboutArticle>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AboutAuthor from "@/components/aboutAuthor";
import AboutArticle from "@/components/aboutArticle";
import {
  getFreeArticleDetail,
  getArticleComment,
  getCommentLike,
  getArctileLike,
  getCollection,
  getPublishComment
} from "@/api/public";
import { getTdkList} from "@/api/tdk";

export default {
  components: {
    AboutAuthor,
    AboutArticle
  },
  data() {
    return {
      authors: [],
      id: "",
      info: {
        cover_url: "",
        title: "FIRST收官，青年作品能拯救电影市场吗？",
        time: "2020年8月3日",
        min: "8",
        byte: "1678",
        praiseNum: "23",
        collectNum: "24",
        laber: "新读数",
        content:
          "持续供应新的青年电影人，FIRST影展按下中国电影重启键。</br> 国电影“每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有.每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样.实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样。持续供应新的青年电影人，FIRST影展按下中国电影重启键。</br> 国电影“每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有.每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样.实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样的预案。实际上所有的预案都丝毫没有 “每一年都是当作最后一届在办，我每天都在想如果有一年我们做不下去了要怎么办，设计了各种各样",
        commentNum: 888
      },
      avatar: require("@/assets/img/avatar.png"),
      commentCont: "", //评价内容
      evaluateList: [], //评论列表
      showall: false,
      showAvatar: true,
      voteList: [
        {
          img: require("@/assets/img/icon_yes.png"),
          title: "合理",
          explain: "骑手依靠佣金挣钱，美团作为上市公司美团也应承担盈利责任",
          per: "60",
          isCheckout: true
        },
        {
          img: require("@/assets/img/icon_no.png"),
          title: "不合理",
          explain: "适当降低佣金，特别是疫情期间",
          per: "30",
          isCheckout: false
        }
      ] //进度条
    };
  },
  methods: {
    getList(id) {
      getFreeArticleDetail(id).then(res => {
        this.info = res.data.data;
        const regex = new RegExp("<img", "gi");
        this.info.content = this.info.content.replace(
          regex,
          `<img style="width: 100%;"`
        );
        this.authors = res.data.data.authors;
      });
    },
    all() {
      this.showall = !this.showall;
    },
    // 评论点赞
    commentBtn(id, i) {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        if (this.evaluateList[i].is_like) {
          this.evaluateList[i].like_times--;
        } else {
          this.evaluateList[i].like_times++;
        }
        this.evaluateList[i].is_like = !this.evaluateList[i].is_like;
        getCommentLike(id).then(res => {});
      }
    },
    // 文章点赞
    praiseBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        getArctileLike(this.id).then(res => {
          this.info.is_like = !this.info.is_like;
          if (this.info.is_like == true) {
            this.info.like_times += 1;
          } else {
            this.info.like_times -= 1;
          }
        });
      }
    },
    // 收藏
    collectionBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        var type = "";
        if (
          this.info.article_type == "sound" ||
          this.info.article_type == "voice"
        ) {
          type = "AudioArticle";
        } else {
          type = "Article";
        }
        getCollection(this.id, type).then(res => {
          this.info.is_favorited = !this.info.is_favorited;
          if (this.info.is_favorited == true) {
            this.info.favorite_times += 1;
          } else {
            this.info.favorite_times -= 1;
          }
        });
      }
    },
    // 发表评论
    publishBtn() {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        var type = "";
        if (
          this.info.article_type == "sound" ||
          this.info.article_type == "voice"
        ) {
          type = "AudioArticle";
        } else {
          type = "Article";
        }
        var params = {
          content: this.commentCont,
          article_type: type
        };
        getPublishComment(this.id, params).then(res => {
          this.commentCont = "";
          this.$message.success("发表成功");
        });
      }
    },
    // 热门标签
    goLaber(id) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "hot_laber",
        params: {
          id: id,
          type: this.info.article_type,
          isSearch: false
        }
      });
    },
    // 相关标签跳标签列表页
    aboutLaber(item) {
      this.resetSetItem("isActive", 0);
      this.$router.push({
        name: "hot_laber",
        params: {
          name: item,
          isSearch: false,
          type: "undefined"
        }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    this.id = this.$route.params.id;
    if (localStorage.getItem("Authorization") != null) {
      var userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.avatar = userInfo.avatar;
      this.showAvatar = false;
    }
    this.getList(this.id);
    // 文章评论
    getArticleComment(this.id).then(res => {
      this.evaluateList = res.data.data;
    });
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.info {
  padding: 30px 30px 20px 30px;
  background: #ffffff;
  margin-bottom: 60px;
  .info-top {
    .message {
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 30px;
        font-weight: bold;
      }
      .mic {
        img {
          width: 100%;
        }
      }
      .num {
        display: flex;
        font-size: 14px;
        color: #999999;
        line-height: 42px;
        align-items: center;
        .laber {
          color: #0091ff;
          margin-left: 30px;
        }
        div {
          margin-left: 30px;
          img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            cursor: pointer;
          }
          span {
            vertical-align: middle;
          }
        }
      }
      .num:nth-child(1) {
        span {
          cursor: pointer;
        }
      }
    }
    .content {
      font-size: 18px;
      line-height: 36px;
      margin-top: 10px;
    }
    .praise {
      margin-top: 130px;
      text-align: center;
      font-size: 18px;
      color: #999999;
      cursor: pointer;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 20px;
    }
    .comment {
      border-top: 1px solid #eeeeee;
      .title {
        margin: 25px 0;
        font-size: 16px;
        font-weight: 600;
      }
      .comment-box {
        display: flex;
        .img {
          margin-right: 20px;
          width: 8%;
          img {
            width: 100%;
            border-radius: 50%;
          }
        }
        .commentInput {
          width: 100%;
          >>> .el-textarea__inner {
            border-radius: 0;
          }
          >>> .el-textarea .el-input__count {
            color: #999999;
            background: #fff;
            position: absolute;
            font-size: 14px;
            bottom: -38px;
            left: 0px;
            width: 40px;
          }
          div {
            margin-top: 12px;
            text-align: right;
            .el-button {
              border-radius: 18px;
              width: 90px;
              height: 36px;
              padding: 0;
              background: #0091ff;
              color: #fff;
            }
          }
        }
      }
      .evaluate {
        li {
          display: flex;
          border-bottom: 1px solid #eeeeee;
          padding-bottom: 60px;
          margin-top: 30px;
          position: relative;
          .img {
            width: 7%;
            height: 7%;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .cont {
            width: 80%;
            font-size: 16px;
            .name {
              line-height: 36px;
              font-weight: 500;
            }
            .time {
              font-size: 14px;
              color: #999999;
            }
            div {
              line-height: 30px;
              margin-top: 10px;
            }
          }
          .like {
            width: 10%;
            position: absolute;
            bottom: 30px;
            right: 0;
            text-align: right;
            span {
              margin-right: 6px;
              color: #999999;
              font-size: 14px;
            }
          }
        }
        li:last-child {
          padding-bottom: 30px;
          border-bottom: none;
          margin-bottom: 10px;
          .like {
            bottom: 0;
          }
        }
      }
    }
  }
}
.imgbtn {
  bottom: -60px;
  position: absolute;
  z-index: 2;
  width: 100%;
  text-align: center;
  color: #0091ff;
  font-size: 18px;
  cursor: pointer;
}
.showall {
  padding: 10px;
  height: 450px;
  overflow: hidden;
  clear: both;
  margin-top: 6px;
}
.showall.active {
  //点击了查看更多，就高度就不管了。随实际的大小变化
  height: auto;
  background: #fff;
  min-height: 150px;
}
.cont-mask {
  position: absolute;
  bottom: 66px;
  width: 100%;
  height: 20px;
  z-index: 2;
  img {
    width: 100%;
    height: auto;
  }
}
.vote {
  text-align: center;
  .tit {
    font-size: 20px;
    font-weight: bold;
    line-height: 36px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: left;
  }
  img {
    width: 150px !important;
    height: 120px !important;
  }
  ul {
    text-align: left;
    li {
      display: flex;
      height: 120px;
      margin-bottom: 20px;
      .img {
        width: 150px;
        background: #f7ffe5;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        line-height: 150px;
      }
      .progress {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: 1px solid #eee;
        padding: 0 20px;
        .cont {
          p {
            color: #999999;
            font-size: 18px;
            line-height: 36px;
          }
          p:nth-child(1) {
            color: #0091ff;
            font-size: 20px;
          }
        }
        .per {
          color: #0091ff;
          font-size: 20px;
        }
      }
    }
    .addClass {
      background: #d8eeff;
    }
    .otherClass {
      background: #eeeeee;
    }
  }
  .voted {
    width: 300px;
    border-radius: 23px;
    color: #0091ff;
    border: 1px solid;
    background: #fff;
    font-size: 16px;
    margin: 50px 0;
    cursor: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myVote/detail.vue